import { TextField, Grid, Typography, MenuItem, Container, Paper } from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";

export default function UnternehmenForm() {
  const { control, getValues } = useFormContext();
  
  const Beschriftung = ({ children }) => (
    <Typography variant="subtitle2" gutterBottom>{children}</Typography>
  );

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
          Unternehmensdaten
        </Typography>
        <Grid container spacing={3} direction="column">
          <Grid item xs={12}>
            <Beschriftung>Firmenname</Beschriftung>
            <Controller
              name="companyName"
              control={control}
              defaultValue={getValues("companyName") || ""}
              render={({ field }) => (
                <TextField {...field} label="Firmenname" fullWidth />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Beschriftung>Adresse</Beschriftung>
            <Controller
              name="location"
              control={control}
              defaultValue={getValues("location") || ""}
              render={({ field }) => (
                <TextField {...field} label="Adresse" fullWidth />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Beschriftung>Rechtsform</Beschriftung>
            <Controller
              name="legalForm"
              control={control}
              defaultValue={getValues("legalForm") || ""}
              render={({ field }) => (
                <TextField {...field} label="Rechtsform" fullWidth />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Beschriftung>Unternehmenszweck</Beschriftung>
            <Controller
              name="purpose"
              control={control}
              defaultValue={getValues("purpose") || ""}
              render={({ field }) => (
                <TextField {...field} label="Unternehmenszweck" fullWidth />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Beschriftung>Gewinnermittlungsart</Beschriftung>
            <Controller
              name="profitMethod"
              control={control}
              defaultValue={getValues("profitMethod") || ""}
              render={({ field }) => (
                <TextField
                  {...field}
                  select
                  label="Gewinnermittlung"
                  fullWidth
                >
                  <MenuItem value="Einnahmen-Überschuss-Rechnung (§ 4 Abs. 3 EStG)">
                    Einnahmen-Überschuss-Rechnung (§ 4 Abs. 3 EStG)
                  </MenuItem>
                  <MenuItem value="Betriebsvermögensvergleich § 4 Abs. 1 EStG">
                  Betriebsvermögensvergleich § 4 Abs. 1 EStG
                  </MenuItem>
                  <MenuItem value="Bilanzierung nach Handels- und Steuerrecht (§ 5 EStG)">
                    Bilanzierung nach Handels- und Steuerrecht (§ 5 EStG)
                  </MenuItem>
                </TextField>
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Beschriftung>Branche</Beschriftung>
            <Controller
              name="specialIndustryFeatures"
              control={control}
              defaultValue={getValues("specialIndustryFeatures") || ""}
              render={({ field }) => (
                <TextField
                  {...field}
                  select
                  label="Branche"
                  fullWidth
                >
                  <MenuItem value="Gesundheitswesen">
                    Gesundheitswesen (z. B. Ärzte, Apotheken, Therapeuten)
                  </MenuItem>
                  <MenuItem value="Steuerberater und Wirtschaftsprüfer">
                    Steuerberater und Wirtschaftsprüfer
                  </MenuItem>
                  <MenuItem value="Handel">
                    Handel (Einzelhandel, Großhandel)
                  </MenuItem>
                  <MenuItem value="Baugewerbe / Architektur / Ingenieurbüros">
                    Baugewerbe / Architektur / Ingenieurbüros
                  </MenuItem>
                  <MenuItem value="Gastronomie / Hotellerie">
                    Gastronomie / Hotellerie
                  </MenuItem>
                  <MenuItem value="IT-Dienstleister / Softwareunternehmen">
                    IT-Dienstleister / Softwareunternehmen
                  </MenuItem>
                  <MenuItem value="Kreativbranche">
                    Kreativbranche (Agenturen, Fotografen, Designer)
                  </MenuItem>
                  <MenuItem value="Produzierendes Gewerbe / Industrie">
                    Produzierendes Gewerbe / Industrie
                  </MenuItem>
                  <MenuItem value="Immobilienunternehmen / Hausverwaltungen">
                    Immobilienunternehmen / Hausverwaltungen
                  </MenuItem>
                     <MenuItem value="Sonstiges">
                    Sonstiges
                  </MenuItem>
                </TextField>
              )}
            />
          </Grid>
        </Grid>
      </Paper>
      <Paper elevation={1} sx={{ p: 3, backgroundColor: "grey.50", borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
          Wichtiger Hinweis
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
          Die Angaben sollten vor der Verwendung von einem Steuerberater oder Rechtsanwalt geprüft werden. Wir übernehmen keine Haftung für die Richtigkeit oder Vollständigkeit der eingegebenen Inhalte.
        </Typography>
      </Paper>
    </Container>
  );
}
